<template></template>
<script>
import { mapState } from 'vuex'

export default {
    name: 'InitMixin',

    data() {
        return {
            form: {},
        }
    },

    computed: {
        ...mapState({
            initCompleted: (state) => state.browsing.initCompleted,
            filters: (state) => state.reportingVM.filters,
            filterOptions: (state) => state.data.options,
        }),

        legalFormOptions() {
            return this.filterOptions.legalForms.filter(
                (item) => item.value > 0
            )
        },
    },

    async created() {
        console.log('launch')
        this.$bvModal.show('time-sheet-alert-modal')
        this.$store.commit('browsing/RESET_INIT_COMPLETED')
        this.initParams()
        await this.$store.dispatch('data/getAllOptions')
        await this.$store.dispatch('reportingVM/getFilters')
        this.$store.commit(
            'todoVM/SET_ACCOUNTING_FIRM_USER_OPTION',
            this.filters.accountingFirmUser
        )
        this.$store.commit('reportingVM/SHOW_VERTICAL_MENU')
        await this.handleCounters()
        this.$store.commit('browsing/SET_INIT_COMPLETED')
    },

    methods: {
        initParams() {
            this.$store.commit('browsing/RESET_PAGE_NAME')
            this.$store.commit('browsing/INIT_DEADLINE_FILTER')
            this.$store.commit('browsing/INIT_TODO_FILTER')
            this.$store.commit('browsing/INIT_ISS_FILTER')
            this.$store.commit('browsing/INIT_VAT_FILTER')
            this.$store.commit('browsing/INIT_TEN_FILTER')
            this.$store.commit('browsing/INIT_PER_PAGE')
            this.$store.commit('browsing/RESET_DEADLINES_TABLE_FILTER')
            this.$store.commit('browsing/INIT_YEAR')
            this.$store.commit('reportingVM/RESET_REPORTING_COUNTERS')
            this.$store.commit('todoVM/RESET_OWN_TASKS_COUNTERS')
            this.$store.commit('todoVM/RESET_DELEGATED_TASKS_COUNTERS')
        },

        async handleOptions() {
            await this.$store.dispatch('data/getLegalFormOptions')
            await this.$store.dispatch('data/getAccountingFirmCompanyOptions')
            await this.$store.dispatch('data/getAccountingFirmUserOptions')
            await this.$store.dispatch('data/getRoleOptions')
            await this.$store.dispatch('data/getBalanceStepOptions')
            await this.$store.dispatch('data/getNationalityOptions')
            await this.$store.dispatch('data/getCountryOptions')
        },

        async initLegalFormFilter() {
            const selected = []
            this.legalFormOptions.forEach((item) => {
                selected.push(item.value)
            })
            this.form.selected = selected
            this.$store.commit('reportingVM/SET_LEGAL_FORM_FILTER', selected)
            // await this.$store.dispatch('reportingVM/setLegalFormFilter', this.form)
        },

        async handleCounters() {
            await this.$store.dispatch('reportingVM/refreshCounters')
            this.$store.commit('reportingVM/SHOW_COUNTERS')

            await this.$store.dispatch('todoVM/refreshCounters')
            this.$store.commit('todoVM/SHOW_COUNTERS')
            // this.$store.commit('todoVM/SHOW_VERTICAL_MENU')
        },
    },
}
</script>
